export default {
      id: "icon-has-mega-menu-usage",
      viewBox: "0 0 17 10",
      url: "../icon/" + "icons.svg#icon-has-mega-menu-usage",
      toString: function () {
        return this.url;
      }
    }